import React from 'react';
import { Link } from 'react-router-dom';
import '../../../styles/components/Footer.css';

export default function Footer() {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-links">
          <Link to="/terms">Terms of Use</Link>
        </div>
        <div className="copyright">
          © {new Date().getFullYear()} Last Layer Trainer. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
} 